import React, { Component } from "react";
import { Form, Button, CarouselItem } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
import Testimonials from "./Testimonials";
// import ReactDOM from "react-dom";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";

export class Home extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntro />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            {/* <header class="section-header">
              <h3>About Us</h3>
              <p>
                Cliptax helps organization and individuals create value they are
                looking for. Cliptax is an independent and integrated
                organization committed to delivering quality in all sorts of
                Taxation and compliance and consultancy services. Our
                experienced and elite professionals provide you with
                exceptional, complete financial and legal solutions on matters
                related to Income tax, financial services, company law matters,
                foreign collaborations, import-export consultancy, GST and
                transfer pricing.
              </p>
            </header> */}

            <div class="row about-container">
              <div
                class="col-lg-7 content order-lg-1 order-2"
                style={{ backgroundColor: "transparent", paddingTop: 12 }}
              >
                <h3
                  style={{
                    fontSize: 28,
                    color: "#004767",
                    fontWeight: 600,
                    alignSelf: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;About Us
                </h3>
                <p
                  style={{
                    fontSize: 15,
                    color: "#000",
                    fontWeight: 500,
                    justifyContent: "true",
                    
                  }}
                >
                 Cliptax
                  helps organization and individuals create value they are
                  looking for. Cliptax is an independent and integrated
                  organization committed to delivering quality in all sorts of
                  Taxation and compliance and consultancy services. Our
                  experienced and elite professionals provide you with
                  exceptional, complete financial and legal solutions on matters
                  related to Income tax, financial services, company law
                  matters, foreign collaborations, import-export consultancy,
                  GST and transfer pricing.               
                  Our
                  experienced and elite professionals provide you with
                  exceptional, complete financial and legal solutions on matters
                  related to Income tax, financial services, company law
                  matters, foreign collaborations, import-export consultancy,
                  GST and transfer pricing.
                </p>
                {/* <div class="icon-box" data-aos="fade-up" data-aos-delay="100" style={{ backgroundColor: "transparent" }}>
                  <div class="icon">
                    <i class="fa fa-shopping-bag"></i>
                  </div>
                  <h4 class="title">
                    <a href="">Taxation</a>
                  </h4>
                  <p class="description">
                    Et harum quidem rerum facilis est et expedita distinctio.
                    Nam libero tempore, cum soluta nobis est eligendi
                  </p>
                </div>

                <div class="icon-box" data-aos="fade-up" data-aos-delay="200" style={{ backgroundColor: "transparent" }}>
                  <div class="icon">
                    <i class="fa fa-photo"></i>
                  </div>
                  <h4 class="title">
                    <a href="">Insurance</a>
                  </h4>
                  <p class="description">
                    Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum
                  </p>
                </div>

                <div class="icon-box" data-aos="fade-up" data-aos-delay="300" style={{ backgroundColor: "transparent" }}>
                  <div class="icon">
                    <i class="fa fa-bar-chart"></i>
                  </div>
                  <h4 class="title">
                    <a href="">Loans</a>
                  </h4>
                  <p class="description">
                    Minim veniam, quis nostrud exercitation ullamco laboris nisi
                    ut aliquip ex ea commodo consequat tarad limino ata
                  </p>
                </div> */}
              </div>

              <div
                class="col-lg-5 background order-lg-2"
                data-aos="zoom-in"
                style={{ backgroundColor: "transparent", paddingTop: -5 }}
              >
                <img
                  src="assets/img/about-img1.jpg"
                  class="img-fluid"
                  alt=""
                  height="400"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="clients" class="section-bg">
          <div class="container" data-aos="fade-up">
            <div class="section-header">
              <h3>Our Partners</h3>
              <br />
              {/* <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque dere santome nida.
            </p> */}
            </div>

            <div
              class="row no-gutters clients-wrap clearfix"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-1.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-2.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-3.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-4.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-5.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-6.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-7.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-xs-6">
                <div class="client-logo">
                  <img
                    src="assets/img/clients/client-8.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <div className="container">
          <Carousel>
            <div>
              <img src="assets/img/testimonial-1.jpg" width="100" height="100"/>
              <p className="legend">Legend 1</p>
            </div>
            <div>
              <img src="assets/img/testimonial-2.jpg" />
              <p className="legend">Legend 2</p>
            </div>
            <div>
              <img src="assets/img/testimonial-3.jpg" />
              <p className="legend">Legend 3</p>
            </div>
          </Carousel>
        </div> */}

        <Testimonials />

        <NewsLetter />
        <Footer />
      </div>
    );
  }
}

export default Home;
